import { render, staticRenderFns } from "./section-results-empty.vue?vue&type=template&id=e6adcef4&scoped=true&"
import script from "./section-results-empty.vue?vue&type=script&lang=js&"
export * from "./section-results-empty.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e6adcef4",
  null
  ,true
)

export default component.exports